export enum UserRole {
  SYSTEM = "SYSTEM",
  TLD_MANAGER = "TLD_MANAGER",
  STAFF = "STAFF",
  STAFF_ADMIN = "STAFF_ADMIN",
  ROOT = "ROOT",
  API = "API",
  SFDC = "SFDC"
}
